import React, { useCallback } from 'react';
import { useArtboardContext, CONTEXT_KEYS } from '../../context/complexArtboardContext'
import { TabMenuItemContainer, IconMenuItem, PremiumIcon } from '../SidebarMenu/styles';
import EditorElement from '../../components/EditorElement';
import { useTranslation } from 'react-i18next';
import { COMPLEX_DESIGN_ELEMENTS } from './translationValues';
import { FREE_HAND_TEXT_ELEMENTS as trans } from '../../utils/masterElements/translationValues';
import { useDocumentContext, COMPLEX_DOCUMENT_CONTEXT_KEYS } from '../../context/complexDocumentContext';
import CustomTooltip from '../../components/CustomTooltip/CustomTooltip';
import { v4 as uuidv4 } from 'uuid';
import { random4Characters } from '../../utils/javascript';

const premiumElementsIds = [6, 7, 9];

const elements = (t, currentLanguage = 'en', currentDesign, isInteractiveDesign = false) => {
  console.log("Lets design tab :: ", currentLanguage, currentDesign);
    return [
    {
      id: 1,
      name: 'text',
      icon: 'font-size',
      displayName: t(COMPLEX_DESIGN_ELEMENTS.TEXT_ELEMENT_LABEL.key, COMPLEX_DESIGN_ELEMENTS.TEXT_ELEMENT_LABEL.value),
      thumbnail: '',
      type: 'text',
      elementDetails: {
        type: 'text',
        style: {},
        variableContract: [],
        contents: [
          {
            contentType: 'PARAGRAPH',
            style: {
              lineSpacing: 1.5,
              fontWeight: [],
              color: '#000000'
            },
            content: t(trans.PARAGRAPH_TEXT.key, trans.PARAGRAPH_TEXT.value)
          },
          {
            contentType: "LINE_BREAK",
            style: {
              lineSpacing: 1.5,
              fontWeight: [],
              color: '#000000'
            }
          }
        ],
        blockType: 'text',
        ...(isInteractiveDesign ? { isEditable: true } : {})
      }
    },
    {
      id: 2,
      name: 'creative',
      icon: 'highlight',
      displayName: t(COMPLEX_DESIGN_ELEMENTS.CREATIVE_BLOCK_ELEMENT_LABEL.key, COMPLEX_DESIGN_ELEMENTS.CREATIVE_BLOCK_ELEMENT_LABEL.value),
      thumbnail: '',
      type: 'creative',
      elementDetails: {
        style: {
          height: 100,
        },
        variableContract: [],
        contents: [],
        type: 'creative',
        blockType: 'creative',
        ...(isInteractiveDesign ? { isEditable: true } : {})
      },
    },
    {
      id: 3,
      name: 'header',
      icon: 'HeaderIcon',
      iconType: 'svg',
      displayName:  t(COMPLEX_DESIGN_ELEMENTS.HEADER_LABEL.key, COMPLEX_DESIGN_ELEMENTS.HEADER_LABEL.value),
      thumbnail: '',
      type: 'header',
      elementDetails: {
        style: {
          height: 100,
        },
        variableContract: [],
        contents: [],
        type: 'header',
        blockType: 'creative',
      },
    },
    {
      id: 4,
      name: 'footer',
      icon: 'FooterIcon',
      iconType: 'svg',
      displayName:  t(COMPLEX_DESIGN_ELEMENTS.FOOTER_LABEL.key, COMPLEX_DESIGN_ELEMENTS.FOOTER_LABEL.value),
      thumbnail: '',
      type: 'footer',
      elementDetails: {
        style: {
          height: 100,
        },
        variableContract: [],
        contents: [],
        type: 'footer',
        blockType: 'creative',
      }
    },
    {
      id: 5,
      name: 'repetitive',
      icon: 'block',
      displayName: t(COMPLEX_DESIGN_ELEMENTS.REPETITIVE_BLOCK_LABEL.key, COMPLEX_DESIGN_ELEMENTS.REPETITIVE_BLOCK_LABEL.value),
      thumbnail: '',
      type: 'creative',
      elementDetails: {
        style: {
          height: 100,
        },
        variableContract: [{
          name: undefined,
          type: 'object',
          content: []
        }],
        contents: [],
        type: 'creative',
        blockType: 'creative',
      },
    },
    {
      id: 6,
      name: 'dynamicTable',
      icon: 'DynamicTableIcon',
      iconType: 'svg',
      displayName: t(COMPLEX_DESIGN_ELEMENTS.DYNAMIC_TABLE_BLOCK_LABEL.key, COMPLEX_DESIGN_ELEMENTS.DYNAMIC_TABLE_BLOCK_LABEL.value),
      thumbnail: '',
      type: 'creative',
      elementDetails: {
        type: "dynamic_table",
        blockType: "dynamic_table",
        variableContract: [
          {
            name: undefined,
            type: "object",
            content: []
          }
        ],
        style: {
          border: {
            thickness: 1,
            borderStyle: "SOLID",
            borderColor: "#000000",
            top: false,
            right: false,
            left: false,
            bottom: false
          },
          padding: {
            left: 5,
            right: 5,
            top: 5,
            bottom: 5
          },
          tableProperties: {
            showHeader: true,
            showHeaderOnAllPages: true,
            showTopBlock: false,
            topBlock: undefined,
            showBottomBlock: false,
            bottomBlock: undefined,
            showtopBlockOnAllPages: false,
            emptyText: [
            {
              contentType: 'PARAGRAPH',
              style: {
                lineSpacing: 1.5,
                fontWeight: [],
                color: '#000000'
              },
              content: ''
            },
            {
              contentType: "LINE_BREAK",
              style: {
                lineSpacing: 1.5,
                fontWeight: [],
                color: '#000000'
              }
            }
          ],
          },
        },
        contents: [
            {
              groupHeaderContent: {
                contentType: "text",
                columnSpan: 1,
                style: {
                  width: 50,
                  border: {
                    thickness: 1,
                    borderStyle: "SOLID",
                    borderColor: "#000000",
                    top: true,
                    right: true,
                    left: true,
                    bottom: true
                  },
                  padding: {
                      left: 2,
                      right: 2,
                      top: 2,
                      bottom: 2
                  }
                },
                contents: [
                  {
                    contentType: "LINE_BREAK",
                    content: "\n",
                    style: {
                      alignment: "center",
                      lineSpacing: 1.5
                    }
                  }
                ]
              },
              headerContent: {
                contentType: "text",
                style: {
                  width: 50,
                  border: {
                    thickness: 1,
                    borderStyle: "SOLID",
                    borderColor: "#000000",
                    top: true,
                    right: true,
                    left: true,
                    bottom: true
                  },
                  padding: {
                      left: 2,
                      right: 2,
                      top: 2,
                      bottom: 2
                  }
                },
                contents: [
                  {
                    contentType: "PARAGRAPH",
                    content: t(COMPLEX_DESIGN_ELEMENTS.DYNAMIC_TABLE_DEFAULT_HEADER.key, COMPLEX_DESIGN_ELEMENTS.DYNAMIC_TABLE_DEFAULT_HEADER.value, { index: 1 }),
                    style: {
                      fontWeight: [],
                      color: '#000000'
                    }
                  },
                  {
                    contentType: "LINE_BREAK",
                    content: "\n",
                    style: {
                      alignment: "center",
                      lineSpacing: 1.5
                    }
                  }
                ]
              },
              content: {
                contentType: "text",
                style: {
                  width: 50,
                  border: {
                    thickness: 1,
                    borderStyle: "SOLID",
                    borderColor: "#000000",
                    top: true,
                    right: true,
                    left: true,
                    bottom: true
                  },
                  padding: {
                    left: 2,
                    right: 2,
                    top: 2,
                    bottom: 2
                  }
                },
                contents: [
                     {
                       contentType: 'PARAGRAPH',
                       style: {
                         lineSpacing: 1.5,
                         fontWeight: [],
                         color: '#000000'
                       },
                       content: ' '
                     },
                     {
                       contentType: "LINE_BREAK",
                       content: "\n",
                       style: {
                         lineSpacing: 1.5,
                         alignment: "center",
                         color: "#000000"
                       }
                     }]
              }
            },
            {
              groupHeaderContent: {
                contentType: "text",
                columnSpan: 1,
                style: {
                  width: 50,
                  border: {
                    thickness: 1,
                    borderStyle: "SOLID",
                    borderColor: "#000000",
                    top: true,
                    right: true,
                    left: true,
                    bottom: true
                  },
                  padding: {
                      left: 2,
                      right: 2,
                      top: 2,
                      bottom: 2
                  }
                },
                contents: [
                  {
                    contentType: "LINE_BREAK",
                    content: "\n",
                    style: {
                      alignment: "center",
                      lineSpacing: 1.5
                    }
                  }
                ]
              },
              headerContent: {
                contentType: "text",
                style: {
                  width: 50,
                  border: {
                    thickness: 1,
                    borderStyle: "SOLID",
                    borderColor: "#000000",
                    top: true,
                    right: true,
                    left: true,
                    bottom: true
                  },
                  padding: {
                      left: 2,
                      right: 2,
                      top: 2,
                      bottom: 2
                  }
                },
                contents: [
                  {
                    contentType: "PARAGRAPH",
                    content: t(COMPLEX_DESIGN_ELEMENTS.DYNAMIC_TABLE_DEFAULT_HEADER.key, COMPLEX_DESIGN_ELEMENTS.DYNAMIC_TABLE_DEFAULT_HEADER.value, { index: 2 }),
                    style: {
                      fontWeight: [],
                      color: '#000000'
                    }
                  },
                  {
                    contentType: "LINE_BREAK",
                    content: "\n",
                    style: {
                      alignment: "center",
                      lineSpacing: 1.5
                    }
                  }
                ]
              },
              content: {
                contentType: "text",
                style: {
                  width: 50,
                  border: {
                    thickness: 1,
                    borderStyle: "SOLID",
                    borderColor: "#000000",
                    top: true,
                    right: true,
                    left: true,
                    bottom: true
                  },
                  padding: {
                    left: 2,
                    right: 2,
                    top: 2,
                    bottom: 2
                  }
                },
                contents: [
                 {
                   contentType: 'PARAGRAPH',
                   style: {
                     lineSpacing: 1.5,
                     fontWeight: [],
                     color: '#000000'
                   },
                   content: ' '
                 },
                 {
                   contentType: "LINE_BREAK",
                   content: "\n",
                   style: {
                     lineSpacing: 1.5,
                     alignment: "center",
                     color: "#000000"
                   }
                 }]
              }
            }
        ]
      }
    },
    {
      id: 7,
      name: 'tableOfContents',
      icon: 'profile',
      displayName: t(COMPLEX_DESIGN_ELEMENTS.TABLE_OF_CONTENTS.key, COMPLEX_DESIGN_ELEMENTS.TABLE_OF_CONTENTS.value),
      thumbnail: '',
      type: 'toc',
      elementDetails:{}
    },
    {
      id: 8,
      name: 'static_table',
      icon: 'table',
      displayName: t(COMPLEX_DESIGN_ELEMENTS.STATIC_TABLE_BLOCK_LABEL.key, COMPLEX_DESIGN_ELEMENTS.STATIC_TABLE_BLOCK_LABEL.value),
      thumbnail: '',
      type: 'static_table',
      elementDetails: {
        variableContract: [],
        type: 'static_table',
        blockType: 'static_table',
        style: {
          height: 120,
          rotate: 0,
          border: {
            thickness: 1,
            borderStyle: 'SOLID',
            borderColor: '#000',
            left: true,
            top: true,
            right: true,
            bottom: true,
          },
          tableProperties: {
            rows: 3,
            columns: 3,
            rowHeights: [40, 40, 40],
          },
        },
        contents: [
          {
            row: 1,
            column: 1,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              verticalAlignment: 'center',
              border: {
                thickness: 1,
                borderStyle: 'SOLID',
                borderColor: '#000000',
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
              },
              backgroundColor: '#00000000',
            },
            contents: [],
            uuid: uuidv4(),
          },
          {
            row: 1,
            column: 2,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              verticalAlignment: 'center',
              border: {
                thickness: 1,
                borderStyle: 'SOLID',
                borderColor: '#000000',
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
              },
              backgroundColor: '#00000000',
            },
            contents: [],
            uuid: uuidv4(),
          },
          {
            row: 1,
            column: 3,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              verticalAlignment: 'center',
              border: {
                thickness: 1,
                borderStyle: 'SOLID',
                borderColor: '#000000',
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
              },
              backgroundColor: '#00000000',
            },
            contents: [],
            uuid: uuidv4(),
          },
          {
            row: 2,
            column: 1,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              verticalAlignment: 'center',
              border: {
                thickness: 1,
                borderStyle: 'SOLID',
                borderColor: '#000000',
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
              },
              backgroundColor: '#00000000',
            },
            contents: [],
            uuid: uuidv4(),
          },
          {
            row: 2,
            column: 2,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              verticalAlignment: 'center',
              border: {
                thickness: 1,
                borderStyle: 'SOLID',
                borderColor: '#000000',
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
              },
              backgroundColor: '#00000000',
            },
            contents: [],
            uuid: uuidv4(),
          },
          {
            row: 2,
            column: 3,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              verticalAlignment: 'center',
              border: {
                thickness: 1,
                borderStyle: 'SOLID',
                borderColor: '#000000',
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
              },
              backgroundColor: '#00000000',
            },
            contents: [],
            uuid: uuidv4(),
          },
          {
            row: 3,
            column: 1,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              verticalAlignment: 'center',
              border: {
                thickness: 1,
                borderStyle: 'SOLID',
                borderColor: '#000000',
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
              },
              backgroundColor: '#00000000',
            },
            contents: [],
            uuid: uuidv4(),
          },
          {
            row: 3,
            column: 2,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              verticalAlignment: 'center',
              border: {
                thickness: 1,
                borderStyle: 'SOLID',
                borderColor: '#000000',
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
              },
              backgroundColor: '#00000000',
            },
            contents: [],
            uuid: uuidv4(),
          },
          {
            row: 3,
            column: 3,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              verticalAlignment: 'center',
              border: {
                thickness: 1,
                borderStyle: 'SOLID',
                borderColor: '#000000',
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
              },
              backgroundColor: '#00000000',
            },
            contents: [],
            uuid: uuidv4(),
          },
        ],
      },
    },
    {
      id: 9,
      name: 'html',
      icon: 'HTML_ICON',
      iconType: 'svg',
      displayName:'HTML',
      thumbnail: '',
      type: 'html',
      elementDetails: {
        style: {
          height: 100,
          lineSpacing: 1.0,
          paragraphSpacing: 0,
        },
        variableContract: [{
          type: 'html',
          content: [],
          name: `html-${random4Characters()}`
        }],
        contents: undefined,
        type: 'html',
        blockType: 'html',
      },
    },
  ];
};

const NAMESPACES = ['COMPLEX_DESIGN_ELEMENTS'];
const STATIC_TYPES = ['header', 'footer', 'tableOfContents'];
const INTERACTIVE_DESIGN_TYPES = ['text', 'creative'];

const LetsDesignTabDetails = (props) => {
  const { currentDesign } = props;
  const customArtboardSelector = useCallback(store => store[CONTEXT_KEYS.CURRENT_BLOCK] === '', []);
  const [draggable] = useArtboardContext(customArtboardSelector, `LetsDesignTabDetails`);

  const  blockTypeSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.REUSABLE_BLOCK_TYPE], []);
  const [reusableBlockType] = useDocumentContext(blockTypeSelector, `LetsDesignTabDetails`);

  const loadingSelector = useCallback(store => store[CONTEXT_KEYS.LOADING_DESIGN], []);
  const [loading] = useArtboardContext(loadingSelector, `LetsDesignTabDetails`);

  const interactiveDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_INTERACTIVE_DESIGN], []);
  const [isInteractiveDesign] = useArtboardContext(interactiveDesignSelector, `LetsDesignTabDetails`);

  const isOpenDesignSelector = useCallback((store) => store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [isOpenDesign] = useArtboardContext(isOpenDesignSelector, `LetsDesignTabDetails`);
  
  const { t, i18n } = useTranslation(NAMESPACES);

  if (loading) return <div />
  
  let staticTypes = STATIC_TYPES;

  if (STATIC_TYPES.includes(reusableBlockType)) {
    staticTypes = ['header', 'footer', 'creative', "dynamicTable", 'repetitive','text', 'tableOfContents'];
  };

  let LetsDesignTabElements = elements(t, i18n.language, currentDesign, isInteractiveDesign).filter(el => {
    if (currentDesign === 'block') {
      return !staticTypes.includes(el.name);
    } else if(currentDesign === 'flow'){
      return !['tableOfContents'].includes(el.name);
    } else if (isInteractiveDesign) {
      return INTERACTIVE_DESIGN_TYPES.includes(el.name);
    }
    return true;
  });

  return (
    <TabMenuItemContainer columnDirection={false}>
        {LetsDesignTabElements?.map((element, elementIndex) => {
          if (elementIndex === 0) {
            return (
              <CustomTooltip title={t(COMPLEX_DESIGN_ELEMENTS.TOOLTIP_TEXT.key, COMPLEX_DESIGN_ELEMENTS.TOOLTIP_TEXT.value)} placement={'bottom'}>
              <IconMenuItem key={element.id} className='mailElements'>
                <EditorElement
                   element={element}
                   clickElement={() => {}}
                   toggleDragging={() => {}}
                   pageSettings={{}}
                   setIsDragAndDropped={() => {}}
                   type={element.type}
                   draggable={draggable}
                 />
              </IconMenuItem>
              </CustomTooltip>
            )
          }
          return (
          <IconMenuItem key={element.id} className='mailElements'>
            {isOpenDesign && premiumElementsIds.includes(element.id) && (
              <PremiumIcon src="/premium.png" alt="premium icon" />
            )}
            <EditorElement
               element={element}
               clickElement={() => {}}
               toggleDragging={() => {}}
               pageSettings={{}}
               setIsDragAndDropped={() => {}}
               type={element.type}
               draggable={draggable}
             />
          </IconMenuItem>
          );
        })}
    </TabMenuItemContainer>
  )
}

export default LetsDesignTabDetails;